export const version = '2.0.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const themeVariants = ['light', 'dark', 'auto'];
export const settings = {
  isFluid: false,
  isRTL: false,
  isDark: false,
  theme: 'light',
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: 'transparent'
};
export const typehome = [ 
  { value: 'apartment', label: 'Appartement', wp_id: 788, en: "Apartment" },  
  { value: 'villa', label: 'Villa', wp_id: 784, en: "Villa"},    
  { value: 'chalet', label: 'Chalet', wp_id: 2050, en: "Chalet" },   
  { value: 'homevillage', label: 'Maison de village', wp_id: 786, en: 'Village house' },   
  { value: 'boutique', label: 'Boutique', wp_id: null, en: "Store" },   
]
export const monthslist = [
  {value : 1, label: 'Janvier'},
  {value : 2, label: 'Février'},
  {value : 3, label: 'Mars'},
  {value : 4, label: 'Avril'},
  {value : 5, label: 'Mai'},
  {value : 6, label: 'Juin'},
  {value : 7, label: 'Juillet'},
  {value : 8, label: 'Août'},
  {value : 9, label: 'Septembre'},
  {value : 10, label: 'Octobre'},
  {value : 11, label: 'Novembre'},
  {value : 12, label: 'Décembre'}, 
]


export const questionsBefore = [
  {
    french: "Votre séjour se prépare",
    english: "Your stay is taking shape",
    detail: "Nous avons à cœur d'anticiper chacun de vos besoins pour que votre arrivée soit aussi fluide que votre séjour.\nPrenez un instant pour nous transmettre vos préférences : nous nous occupons du reste.",
    detailEn: "To ensure everything is perfectly in place upon your arrival, take a moment to share your preferences."
  },
  {
    type: 'checkbox', // Type de champ pour les services
    french: "Services souhaités durant votre séjour :",
    english: "Services required during your stay:",
    options: [
      "Activités et découvertes locales / Local experiences",
      "Chef privé / Private Chef",
      "Excursions en mer / Boat Excursions",
      "Majordome / Butler",
      "Chauffeur privé / Private Chauffeur",
      "Femme de ménage supplémentaire / Extra Maid",
      "Réservations de restaurants / Restaurant Reservations",
      "Transferts aéroport / Airport Transfers",
      "Organisation de journées en bateau / Boat day trips",
      "Activités locales / Local activities",
      "Location de voiture / Car Rental",
      "Massages et soins bien-être / Massages & Wellness Treatements",
      "Garde d'enfants / Childcare Service",
      "Service de sécurité / Private Security",
    ],
    detail: "Merci de remplir les champs de carte bleue pour les réservations de restaurants.",
    detailEn:"Thanks for filling out the credit card fields for restaurant reservations."
  },
  {
    type: 'radio', // Question de type Oui/Non pour les allergies
    french: "Avez-vous des intolérances ou allergies alimentaires ?",
    english: "Do you have any food intolerances or allergies?",
    options: ["Oui / Yes", "Non / No"]
  },
  {
    type: 'checkbox', // Allergies spécifiques si l'utilisateur répond "Oui"
    french: "Si oui, cochez vos allergies alimentaires :",
    english: "If yes, check your food allergies:",
    options: [
      "Gluten / Gluten",
      "Crustacés / Shellfish",
      "Œufs / Eggs",
      "Poissons / Fish",
      "Arachides / Peanuts",
      "Soja / Soy",
      "Lactose / Lactose",
      "Fruits à coque / Nuts",
      "Céleri / Celery",
      "Moutarde / Mustard",
      "Sésame / Sesame",
      "Sulfites / Sulfites",
      "Lupin / Lupin",
      "Mollusques / Mollusks",
      "Autre / Other"
    ],
    dependentOn: "allergies"
  },
  {
    type: 'radio', // Question pour les préférences alimentaires
    french: "Préférences alimentaires spécifiques : (Oui / Non)",
    english: "Specific dietary preferences: (Yes / No)",
    options: ["Oui / Yes", "Non / No"]
  },
  {
    type: 'checkbox', // Liste des préférences alimentaires spécifiques
    french: "Si oui, cochez vos préférences :",
    english: "If yes, check your preferences:",
    options: [
      "Végétarien / Vegetarian",
      "Végétalien / Vegan",
      "Pescétarien / Pescatarian",
      "Flexitarien / Flexitarian",
      "Sans porc / No pork",
      "Sans alcool / No alcohol",
      "Halal / Halal",
      "Kasher / Kosher",
      "Sans lactose / Lactose-free",
      "Sans gluten / Gluten-free",
      "Pauvre en sucre / Low sugar / Diabetic",
      "Sans fruits de mer / No seafood",
      "Sans noix / No nuts",
      "Crudivore / Raw food",
      "Paléo / Paleo",
      "Keto / Cétogène / Keto / Ketogenic",
      "Régime méditerranéen / Mediterranean diet",
      "Régime pauvre en sel / Low salt diet",
      "Autre / Other"
    ],
    dependentOn: 'preferences' // Cette question est dépendante de la réponse précédente
  },
  {
    french: "Heure prévue d'arrivée",
    english: "Expected Arrival Time",
    type: "text",
    detail: "Ex : 14:30",
    detailEn: "Ex : 2:30 PM"
  },
  {
    french: "Mode de transport (avion, train, voiture)",
    english: "Mode of Transport (plane, train, car)",
    type: "text",
    detail: "Ex : Avion, Train, Voiture",
    detailEn: "Ex : Plane, Train, Car"
  },
  {
    french: "Préparons tout pour vos enfants",
    english: "Let's ensure everything is ready for your",
    type: "textarea",
    detail: "Exemple : Lit bébé, chaise haute",
    detailEn:"Ex : Bed, high chair",
    placeholder: "Si vous avez des besoins spécifiques pour vos enfants, indiquez-les ici afin que tout soit en place à votre arrivée.\nIf you have specific needs for your children, let us know so everything is ready upon your arrival."
  },
  {
    type:"radioyes", 
    french:
      "Souhaitez-vous une livraison de courses avant votre arrivée ? Si oui, précisez vos besoins ainsi que les quantités souhaitées.",
    english:
      "Would you like groceries delivered before your arrival? If yes, please specify your needs and the desired quantities.",
    // placeholder: "", 
    detail: "Ex : Oui, 2 bouteilles de lait, 1 pain\n\nFrais de livraison : 90 € HT\nFrais de courses : 10 % du montant total des achats HT + TVA 20 %\n\nDelivery fee: 90 € HT\nShopping fee: 10% of the total amount of purchases HT + VAT 20 %",
    detailEn: "Yes, 2 bottles of milk, 1 bread\n\nDelivery fee: 90 € HT\nShopping fee: 10% of the total amount of purchases HT + VAT 20 %",
    options: ["Oui / Yes", "Non / No"]
  },
  {
    french: "Entrez les informations de votre carte bleue",
    english: "Enter your credit card information",
    type: "card", // Nouveau type
    options: null, // Pas d'options, les champs sont fixes  
    detail: "Nécessaire pour les réservations au restaurant ou les courses. Need for restaurant bookings or grocery delivery.",
    detailEn: "Need for restaurant bookings or grocery delivery.",
    dependentOn: "radioyes",
    check: {value: 1 , label :"Réservations de restaurants / Restaurant Reservations"}
  },
  {
    type: 'textarea', // Question pour les demandes spécifiques
    french: "Une demande particulière en tête ?",
    english: "A special request?",
    detail:"Faites-nous part de vos envies, nous nous chargeons du reste avec la plus grande attention.",
    detailEn:"Let us know your wishes, and we will take care of everything with the utmost discretion and care."
  },
  {
    french: "Nous vous remercions",
    english: "Thank you",
    detail: "Votre attention aux détails nous permet de vous offrir un séjour à la mesure de vos attentes.\nNous nous réjouissons de vous accueillir très prochainement.",
    detailEn: "Your attention to detail allows us to create a stay that meets your highest expectations.\nWe look forward to welcoming you soon.",
    type : "send"
  }
];

export const questionsSatisfaction = [ 
  {
    french: "Votre expérience avec Bo-House",
    english: "Your experience with Bo-House",
    detail: "Afin d’améliorer votre satisfaction, nous vous remercions de prendre quelques courtes minutes pour répondre à ce petit questionnaire.",
    detailEn: "In order to improve your satisfaction, we thank you for taking a few minutes to answer this short questionnaire."
  },
  {
    type: "ratings",
    french: "Votre satisfaction",
    english: "Your satisfaction",
    max: 5,
    detail: "Sur une échelle de 1 à 5, comment évalueriez-vous votre séjour dans votre villa/appartement ?",
    detailEn:"On a scale of 1 to 5, how would you rate your stay in your villa/apartment?"
  },
  {
    max: 5,
    type: "ratings",
    french: "Votre hébergement",
    english: "Your accommodation",
    detail:"Comment évalueriez-vous la propreté et l'entretien de votre logement ?",
    detailEn: "How would you rate the cleanliness and maintenance of your accommodation?"
  },
  {
    max: 5,
    type: "ratings",
    french: "Le confort et les équipements fournis dans la propriété étaient-ils satisfaisants ?",
    english: "Was the comfort and the equipment provided in the property satisfactory?",
  },
  {
    type: "textarea",
    french: "Y a-t-il des améliorations ou des équipements supplémentaires que vous auriez souhaités ?",
    english: "Are there any improvements or additional amenities you would have liked?",
  },
  {
    type: "checkbox",
    french: "Service de conciergerie",
    english: "Concierge service",
    detail: "Quels services avez-vous sollicités durant votre séjour ?",
    detailEn: "Which services did you request during your stay?",
    options: [ 
      "Réservations de restaurants / Restaurant Bookings",
      "Transports privés (hélicoptère, transferts, mise à disposition) / Private Transportation (Helicopter, Transfers, On-Demand Service)",
      "Personnel dédié (chef, majordome, nounou) / Dedicated Staff (Chef, Butler, Nanny)",
      "Sécurité privée / Private Security",
      "Autre / Other"
    ],
  },
  {
    type: "radiono",
    options: ["Oui / Yes", "Non / No"],
    detail: "Pourquoi ? / Why ? ",
    french: "Les services proposés (réservations, transferts, chef privé, etc.) ont-ils répondu à vos besoins ?",
    english: "Did the services provided (reservations, transfers, private chef, etc.) meet your needs?",
  },
  {
    type: "textarea",
    french: "Avez-vous des recommandations pour enrichir notre offre de services (points d’amélioration, services complémentaires) ?",
    english: "Do you have any recommendations to enrich our service offering (areas for improvement, additional services)?",
  },
  {
    type: "ratings",
    french: "Communication : Sur une échelle de 1 à 5, notez la réactivité et la disponibilité des équipes",
    english: "Communication: On a scale of 1 to 5, rate the responsiveness and availability of the teams.",
    max: 5,
  },
  {
    type: "textarea",
    french: "Points forts : Qu’avez-vous particulièrement apprécié lors de votre séjour (propriété, services, localisation, etc.) ?",
    english: "Highlights: What did you particularly enjoy during your stay (property, services, location, etc.)?",
  },
  {
    type: "radiono",
    french: "Recommanderiez-vous notre service à vos amis ou votre entourage ? (Oui/Non, pourquoi ?)",
    english: "Would you recommend our service to your friends or family? (Yes/No, why?)",
    options: ["Oui / Yes", "Non / No"],
    detail: "Pourquoi ? / Why ? "
  },
  // {
  //   type: "textarea",
  //   french: "Points à améliorer : Y a-t-il eu des aspects de votre séjour que vous n’avez pas trouvés satisfaisants ? Si oui, lesquels ?",
  //   english: "Areas for improvement: Were there aspects of your stay that you were not satisfied with? If so, which ones?",
  // },
  // {
  //   type: "radio",
  //   french: "Les problèmes rencontrés ont-ils été résolus à votre satisfaction ?",
  //   english: "Were the issues you encountered resolved to your satisfaction?",
  //   options: ["Oui / Yes", "Non / No"],
  //   dependentOn: "problems",
  // },
  {
    type: "radio",
    french: "Avis et recommandations : Accepteriez-vous de laisser un commentaire public ou une note sur notre site ou nos réseaux sociaux ?",
    english: "Feedback and recommendations: Would you agree to leave a public comment or rating on our website or social media?",
    options: ["Oui / Yes", "Non / No"],
    detail: "Un lien vous sera fourni. A link will be provided."
  },
  {
    type: "radio", 
    french : "Comment avez-vous connu Bo-House ?",
    english: "How did you hear about Bo-House ?",
    options: 
    [
      "En cherchant sur internet / | found it online",
      "Via une annonce Google / Through a Google ad",
      "En recevant un email / I received an email",
      "Par un messagerie privée / Through a private message",
      "Sur les réseaux sociaux / I saw it on social media",
      "Grâce à une publicité sur les réseaux sociaux / Through a social media ad",
      "Par le bouche-à-oreille / Someone recommended it to me",
      "Grace à de la publicité",
      "Via agence partenaire / Through a partner agency",
      "Grâce à un influenceur / Through an influencer",
      "Via un média hors ligne (magazine, flyer...) / Offline media (magasine, flyer...)"
    ]
  }, 
  {
    french: "Nous vous remercions",
    english: "Thank you",
    detail: "Votre retour nous est précieux et nous permet de toujours mieux anticiper vos attentes.\nAu plaisir de vous accueillir à nouveau.",
    detailEn: "Your feedback is invaluable and helps us better anticipate your expectations.\nWe look forward to welcoming you again.",
    type : "send"
  }
];

export const api = 'ja4t4ng0mg351ypmshfp5nslkv6hyv73nua0q3vka0h5po5z';
export default {monthslist, typehome,  version, navbarBreakPoint, topNavbarBreakpoint, settings, api };


export const nationalities = [
  'Afghane',
  'Albanaise',
  'Algérienne',
  'Allemande',
  'Américaine',
  'Andorrane',
  'Anglais',
  'Anglaise',
  'Angolaise',
  'Antiguaise et Barbudienne',
  'Argentine',
  'Arménienne',
  'Australienne',
  'Azerbaïdjanaise',
  'Bahaméenne',
  'Bahreinienne',
  'Bangladaise',
  'Barbadienne',
  'Bélizienne',
  'Béninoise',
  'Bermudienne',
  'Belge',
  'Bhoutanaise',
  'Bielorusse',
  'Birmane',
  'Bolivienne',
  'Bosnienne',
  'Botswanaise',
  'Brésilienne',
  'Britanique',
  'British',
  'Brunéienne',
  'Bulgare',
  'Burkinabè',
  'Burundaise',
  'Cambodgienne',
  'Camerounaise',
  'Canadienne',
  'Cap-verdienne',
  'Centrafricaine',
  'Chilienne',
  'Chinoise',
  'Colombienne',
  'Comorienne',
  'Congolaise (République du Congo)',
  'Congolaise (République Démocratique du Congo)',
  'Coréenne', 
  'Costaricienne',
  'Croate',
  'Cubaine',
  'Cypriote',
  'Tchadienne',
  'Danoise',
  'Djiboutienne',
  'Dominicaine',
  'Dominicaine (Dominique)',
  'Équatorienne',
  'Égyptienne',
  'Emiratie',
  'Équatorienne',
  'Érythréenne',
  "Espagnole",
  'Estonienne',
  'Eswatinienne',
  'Éthiopienne',
  'Fidjienne',
  'Finlandaise', 
  'Français', 
  'Française',
  'Gabonienne',
  'Gambienne',
  'Géorgienne',
  'Ghanéenne',
  'Gibraltarienne',
  'Grecque',
  'Grenadienne',
  'Guatémaltèque',
  'Guinéenne',
  'Guinéenne-Bissau',
  'Guyanienne',
  'Haïtienne',
  'Hondurienne',
  'Hongroise',
  'Hollandaise',
  'Indienne',
  'Indonésienne',
  'Irakienne',
  'Irlandaise',
  'Islandaise',
  'Israélienne',
  'Italienne',
  'Jamaïcaine',
  'Japonaise',
  'Jordanienne',
  'Kazakhstanaise',
  'Kényane',
  'Kirghize',
  'Kiribatienne',
  'Kittitienne',
  'Koweïtienne',
  'Laotienne',
  'Lesothane',
  'Lettonne',
  'Libanaise',
  'Libérienne',
  'Libyenne',
  'Liechtensteinoise',
  'Lituanienne',
  'Luxembourgeoise',
  'Macédonienne',
  'Madagascaraise',
  'Malawienne',
  'Malaisienne',
  'Maldivienne',
  'Maliénne',
  'Maltaise',
  'Marocaine',
  'Marshallienne',
  'Mauricienne',
  'Mauritanienne',
  'Mexicaine',
  'Micronésienne',
  'Monégasque',
  'Mozambicaine',
  'Namibienne',
  'Nauruane',
  'Népalaise',
  'Nicaraguayenne',
  'Nigeriane',
  'Nihonaise',
  'Norvégienne',
  'Nouvelle-zélandaise',
  'Omanienne',
  'Ougandaise',
  'Pakistanaise',
  'Palestinienne',
  'Panaméenne',
  'Papouasienne-Nouvelle-Guinéenne',
  'Paraguayenne',
  'Péruvienne',
  'Philippine',
  'Polonaise',
  'Portoricaine',
  'Portugaise',
  'Qatarienne',
  'Roumaine',
  "Russe",
  'Rwandaise',
  'Saint-Kittsienne-et-Nevisienne',
  'Saint-Lucienne',
  'Saint-Marinaise',
  'Saint-Vincentaise',
  'Salvadorienne',
  'Samoane',
  'Sao-Toméenne',
  'Sénégalaise',
  'Serbe',
  'Seychelloise',
  'Sierra-Léonaise',
  'Singapourienne',
  'Slovaque',
  'Slovène',
  'Solomonaise',
  'Somalienne',
  'Sud-africaine',
  'Suisse',
  'Suédoise',
  'Soudanaise',
  'Sri-lankaise',
  'Sud-soudanaise',
  'Surinamaise',
  'Syrienne',
  'Tadjikiste',
  'Tanzanienne',
  'Thaïlandaise',
  'Togolaise',
  'Tongienne',
  'Trinidadienne',
  'Tunisienne',
  'Turkmène',
  'Turque',
  'Tuvaluane',
  'USA',
  'Uruguayenne',
  'Vénézuélienne',
  'Vanuatuane',
  'Vaticane',
  'Vénézuélienne',
  'Yéménite',
  'Zambienne',
  'Zimbabwéenne',
];